// extracted by mini-css-extract-plugin
export default {"container":"quote_container__FQqD8","wrapper":"quote_wrapper__BX3Pv","quotediv":"quote_quotediv__Hyafz","quoteimg":"quote_quoteimg__IDmpj"};